import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { ContactPage } from "./components/ContactPage";
import { ProductsPage } from "./components/ProductsPage";
import { IndividualProductPage } from "./components/IndividualProductPage";
import { AboutPage } from "./components/AboutPage";
import { DistributorPage } from "./components/DistributorPage";
import { BlogPage } from "./components/BlogPage";
import { BlogPostPage } from "./components/BlogPostPage";
import { PrivacyPolicyPage } from "./components/PrivacyPolicyPage";
import { BrandAmplePage } from "./components/BrandAmplePage";
import { PdfViewerPage } from "./components/PdfViewerPage";

// Component to handle scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return null;
};

function AppContent() {
  const location = useLocation();
  const isPdfViewer = location.pathname === "/view-pdf";

  if (isPdfViewer) {
    return (
      <div className="bg-white min-h-screen select-none" style={{ overflowX: "clip" }}>
        <Routes>
          <Route path="/view-pdf" element={<PdfViewerPage />} />
        </Routes>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen select-none" style={{ overflowX: "clip" }}>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:slug" element={<IndividualProductPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/distributor" element={<DistributorPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/brands/ample" element={<BrandAmplePage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
